import React from 'react';

function TestimonialV3() {
	let publicUrl = process.env.PUBLIC_URL + '/';

	return (
		<div
			className="testimonial-area"
			style={{
				background: 'white', // Set background to white
				padding: '40px',
				marginBottom: '20px'
			}}
		>
			<div className="bg-overlay-wrap">
				<div className="container">
					<div className="section-title style-white text-center">
					{/* <h6 style={{ color: '#10374A' }}>Our Testomonial</h6> */}
						<h2 style={{ color: '#10374A', fontSize:'1.5rem'}}>What Our Clients Say</h2>
					</div>
					<div className="row justify-content-center">
						<div className="col-lg-10">
							<div className="testimonial-slider-1 owl-carousel">
								<div className="item">
									<div className="single-testimonial-inner pl-lg-5 pr-lg-5 text-center">
										<div className="thumb">
											<img src={publicUrl + "assets/img/testimonial/quote.png"} alt="img" style={{
												filter: 'invert(26%) sepia(89%) saturate(2166%) hue-rotate(180deg) brightness(89%) contrast(93%)'
											}} />
										</div>
										<div className="details">
											<p style={{ color: '#10374A' }}>
												{/* “I bought a house with Face to Face as the estate agent and, later on, sold it, with them, as my agent. I had an excellent service with them both times. They supported me every step of the way and I would heartily recommend them, and have recommended them to both friends and neighbours. Don't use anybody else !!!’’ */}
											</p>
										</div>
									</div>
								</div>
								<div className="item">
									<div className="single-testimonial-inner pl-lg-5 pr-lg-5 text-center">
										<div className="thumb">
											<img src={publicUrl + "assets/img/testimonial/quote.png"} alt="img" style={{
												filter: 'invert(26%) sepia(89%) saturate(2166%) hue-rotate(180deg) brightness(89%) contrast(93%)',
											}} />
										</div>
										<div className="details">
											<p style={{ color: '#10374A' }}>
												“After having my property valued by different estate agents, I chose Face 2 Face. From first valuation to final completion, the service was first class carried out by very knowledgeable and extremely friendly staff. Nothing was too much trouble. Would highly recommend. Thank you all for making it a very pleasant experience.’’
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default TestimonialV3;
